import { render, staticRenderFns } from "./cancelados.vue?vue&type=template&id=2ed19422&scoped=true&"
import script from "./cancelados.vue?vue&type=script&lang=js&"
export * from "./cancelados.vue?vue&type=script&lang=js&"
import style0 from "./cancelados.vue?vue&type=style&index=0&id=2ed19422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed19422",
  null
  
)

export default component.exports